import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { jobsBackend } from './jobs.backend';
import { jobsReducer } from './jobs.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('jobs', jobsReducer),
    BackendModule.forFeature('jobs', jobsBackend),
  ],
})
export class DatastoreJobsModule {}
